import { render, staticRenderFns } from "./UserEmailRenderer.vue?vue&type=template&id=28ca2c1c&"
import script from "./UserEmailRenderer.vue?vue&type=script&lang=ts&"
export * from "./UserEmailRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports